import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "my-1" }
const _hoisted_2 = { class: "text-primary me-1" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "table table-sm"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col"),
  /*#__PURE__*/_createElementVNode("col"),
  /*#__PURE__*/_createElementVNode("col"),
  /*#__PURE__*/_createElementVNode("col")
], -1)
const _hoisted_6 = { class: "bg-light" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_11 = {
  key: 2,
  class: "text-center"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_Icon, {
          glyph: "arrow-right",
          sm: "",
          style: _normalizeStyle({ transform: _ctx.expanded ? 'rotate(90deg)' : '' })
        }, null, 8, ["style"])
      ]),
      _createElementVNode("a", {
        href: "",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.loadConfiguredOptions && _ctx.loadConfiguredOptions(...args)), ["prevent"]))
      }, _toDisplayString(_ctx.productId), 1)
    ]),
    (_ctx.expanded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.hasBeenLoaded && _ctx.configurator?.groups?.length)
            ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_6, [
                    _createElementVNode("th", null, [
                      _createElementVNode("small", null, _toDisplayString(_ctx.t('Product')), 1)
                    ]),
                    _createElementVNode("th", null, [
                      _createElementVNode("small", null, _toDisplayString(_ctx.t('Description')), 1)
                    ]),
                    _createElementVNode("th", null, [
                      _createElementVNode("small", null, _toDisplayString(_ctx.t('Quantity')), 1)
                    ]),
                    _createElementVNode("th", null, [
                      _createElementVNode("small", null, _toDisplayString(_ctx.t('UnitOfMeasure')), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configurator.groups, (confGroup) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: confGroup.groupName
                    }, [
                      _createElementVNode("tr", null, [
                        _hoisted_7,
                        _createElementVNode("td", null, [
                          _createElementVNode("strong", null, _toDisplayString(confGroup.name), 1)
                        ]),
                        _hoisted_8,
                        _hoisted_9
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(confGroup.elements, (groupItem) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: groupItem.itemCode
                        }, [
                          _createElementVNode("td", null, _toDisplayString(groupItem.product), 1),
                          _createElementVNode("td", null, _toDisplayString(groupItem.description), 1),
                          _createElementVNode("td", null, _toDisplayString(groupItem.quantity), 1),
                          _createElementVNode("td", null, _toDisplayString(groupItem.unitOfMeasure), 1)
                        ]))
                      }), 128))
                    ], 64))
                  }), 128))
                ])
              ]))
            : (_ctx.hasBeenLoaded)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.t('NoOptionsAvailable')), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}